import { Button, H2, IconExpand } from "@touche-lts/panel-ui/dist";
import cl from "classnames";
import React, { useState } from "react";
import { IconInfoSmall } from "../../../../assets/icons";
import { AddShippingDTO } from "../../../../models/shipping";
import styles from "../add-store-page.module.scss";
import shippingStyles from "./shipping-field.module.scss";
import ShippingItem from "./shipping-item";
import ShippingEdit from "./shipping-edit";

interface ShippingFieldProps {
  className?: string;
  style?: React.CSSProperties;
  shippings: AddShippingDTO[];
  onShippingsChange: (shippings: AddShippingDTO[]) => void;
}

const ShippingField: React.FC<ShippingFieldProps> = (props) => {
  const { shippings, onShippingsChange } = props;
  const [isAddNewShipping, setIsAddNewShipping] = useState(false);
  const [editingShipping, setEditingShipping] = useState<number | null>(null);

  const removeShipping = (index: number) => {
    const newShippings = [...shippings];
    newShippings.splice(index, 1);
    onShippingsChange(newShippings);
  };

  return (
    <div>
      <H2 className={cl(styles.sectionHeading, shippingStyles.flexGap2ItemsCenter)}>
        Shipping options{" "}
        <IconInfoSmall title="Some info about shipping options" />
      </H2>
      {shippings.map((shipping, index) => {
        return (
          <React.Fragment key={index}>
            {index !== editingShipping ? (
              <ShippingItem
                key={index}
                shipping={shipping}
                onEdit={(index) => {
                  setEditingShipping(index);
                  setIsAddNewShipping(false);
                }}
                onRemove={(index) => removeShipping(index)}
                index={index}
              />
            ) : (
              <ShippingEdit
                value={shipping}
                onEdit={(shipping: AddShippingDTO) => {
                  setIsAddNewShipping(false);
                  setEditingShipping(null);
                  onShippingsChange(
                    shippings.map((s, i) => (i === index ? shipping : s))
                  );
                }}
                onCancel={() => {
                  setIsAddNewShipping(false);
                  setEditingShipping(null);
                }}
              />
            )}

            <div className={shippingStyles.shippingDivider} />
          </React.Fragment>
        );
      })}

      {isAddNewShipping && (
        <ShippingEdit
          onSave={(shipping: AddShippingDTO) => {
            setIsAddNewShipping(false);
            onShippingsChange([...shippings, shipping]);
          }}
          onCancel={() => setIsAddNewShipping(false)}
        />
      )}

      {!isAddNewShipping && (
        <Button
          preset="link"
          style={{ marginTop: 30 }}
          onClick={() => {
            setIsAddNewShipping(true);
            setEditingShipping(null);
          }}
        >
          <IconExpand style={{ marginRight: 8, fill: styles.primary }} />
          Add{shippings.length > 0 && " another"} option
        </Button>
      )}
    </div>
  );
};

export default ShippingField;
